import {
    type FC
} from "react";
import type IDropdownMenuLabelProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import {
    useDropdownMenuHeadingInset
} from "../../hook";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuLabel: FC<IDropdownMenuLabelProps> = ({
    customTheme: customThemeProp,
    title
}) => {
    const context = useDropdownMenuContext({
        part: "Label"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const insetDynamicStyle = useDropdownMenuHeadingInset({
        part: "Label",
        customTheme
    });

    return <PopoverSurface.Heading
        customTheme={customTheme}
        style={insetDynamicStyle}
    >
        {title}
    </PopoverSurface.Heading>;
};
export default DropdownMenuLabel;
